if (!process.env.NEXT_PUBLIC_API_URL) {
  throw new Error('NEXT_PUBLIC_API_URL environment variable is required')
}

export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_API_URL,
  VERSION: 'v1',
} as const

/** Where an assistant connects, whichever credential it presents. */
export const MCP_SERVER_URL = `${API_CONFIG.BASE_URL}/api/${API_CONFIG.VERSION}/mcp`
